import { combineAllWatchers } from '@sonar-software/xuder';
import { combineReducers } from 'redux';
import { coreInitiativesSummaryGetAsyncSlice } from './get';

export const coreInitiativesSummaryReducers = combineReducers({
	get: coreInitiativesSummaryGetAsyncSlice.asyncReducers
});

export const coreInitiativesSummaryWatchers = combineAllWatchers([ coreInitiativesSummaryGetAsyncSlice.asyncWatchers ]);
